import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesJuiceBar = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
         console.log('clickd')
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='juicebar'
                        src={`${process.env.PUBLIC_URL}/images/system/system-juicebar-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        La Buvette vous permet de redistribuer l'expérience accumulée entre différents personnages. Plus
                        vous montez le niveau de la Buvette,{' '}
                        <span className='text-pborange'>plus vous pourrez accumuler d'expérience</span>.
                    </p>{' '}
                    <br />
                    <p>
                        Grâce à la Buvette, vous pouvez accroître en un instant le niveau d'un allié nouvellement créé,
                        ou accroître le niveau d'un allié réincarné au-delà du niveau 1. Il s'agit d'un outil
                        extrêmement pratique pour renforcer vos personnages !
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'juicebar',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        Si vous augmentez le taux d'EXP stockée à la Buvette au-delà de 100 %, les personnages que vous
                        déployez au combat gagneront <span className='text-pborange'>0 EXP</span>, mais la quantité
                        d'EXP que recevra la Buvette <span className='text-pborange'>dépassera 100 %</span> ! Sacrée
                        affaire !
                    </p>
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
}
